<template>
  <div class="input-wrapper password-input-wrapper">
    <app-icon
      v-if="showLockIcon"
      name="lock"
      size="24"
      class="form-icon"
    />

    <input
      :type="showPassword ? 'text' : 'password'"
      :name="name"
      :id="id"
      :class="[inputClass, { error: error, 'no-icon': !showLockIcon }]"
      :placeholder="placeholder"
      :value="value"
      :autocomplete="autocomplete"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event)"
    />

    <button
      type="button"
      class="pwd-toggle-btn"
      @click="togglePassword"
      :aria-label="showPassword ? 'Hide password' : 'Show password'"
      tabindex="-1"
    >
      <!-- Eye Open (when password visible) -->
      <app-icon
        v-if="showPassword"
        name="eye"
        size="20"
      />
      <!-- Eye Off (when password hidden) -->
      <app-icon
        v-else
        name="eye-off"
        size="20"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: 'password',
    },
    name: {
      type: String,
      default: 'password',
    },
    placeholder: {
      type: String,
      default: '••••••••',
    },
    inputClass: {
      type: String,
      default: 'form-input',
    },
    showLockIcon: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: 'current-password',
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
.password-input-wrapper input {
  padding-right: 42px !important;
  width: 100%;
}
.pwd-toggle-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  z-index: 2;
}
.pwd-toggle-btn:hover {
  color: #111827;
}
</style>
